// global
import React from 'react';
// import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// components
import PopupButton from 'app/components/commons/button/PopupButton';
// redux
import { openUpdate as open } from 'app/redux/actions/modal/save-update-modal.action';
import { openChangeStatusModal } from 'app/redux/actions/modal/change-status-modal.action';
// import * as HealthProfessional from 'app/api/health-professional';
//style
import '../profession/PopupProfession.scss';

function PopupHealthProfessional(props) {
  const onClickEdit = entity => () => {
    props.dispatch(open({ ...entity }));
  };

  const onChangeStatus = entity => () => {
    props.dispatch(openChangeStatusModal({ ...entity, action: entity.status }));
  };

  const { row } = props;

  const isActive = row && row.status === 1;

  return (
    <PopupButton
      entity={row}
      onClickEdit={onClickEdit}
      onChangeStatus={onChangeStatus}
      tagChangeStatusButton={isActive ? 'Desativar' : 'Ativar'}
    />
  );
}

PopupHealthProfessional.propTypes = {
  auth: PropTypes.object,
  row: PropTypes.object,
  dispatch: PropTypes.func,
  allProfession: PropTypes.array
};

const mapStateToProps = state => ({
  auth: state.auth,
  healthProfessional: state.healthProfessional,
  data: state.data
});
export default connect(mapStateToProps)(PopupHealthProfessional);
